<template>
  <div class="text-13 h-6 flex items-center" :class="{ 'text-red-500': transitionText === 'Invalid Step!' }" v-html="transitionText"></div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { getTransitionText } from '@/helpers/flow';

export default {
  name: 'TransitionOverview',
  props: {
    item: Object,
    evaluate: Array,
  },
  computed: {
    ...mapState(['selectedIntentDefinition']),
    ...mapGetters(['getProjectFlows']),
    transitionText() {
      if (this.item.payload.type === 'step') {
        return getTransitionText(this.payload, this.selectedIntentDefinition.steps);
      }
      if (this.item.payload.type === 'agent') {
        return getTransitionText(this.payload, [], this.flows);
      }
      return `${this.$t('evaluate_editor.logic-transition')}: ${getTransitionText(this.payload, this.selectedIntentDefinition.steps)}`;
    },
    payload() {
      return this.item.payload;
    },
    flows() {
      return Object.keys(this.getProjectFlows()).map((key) => ({
        label: this.getProjectFlows()[key].name,
        value: key,
      }));
    },
  },
};
</script>
